import React from 'react'
import ReportsDetailsViewHeader from './ReportsDetailsViewHeader'
import ReportsDetailsViewOverview from './ReportsDetailsViewOverview'

const ReportsDetailsViewPage = () => {
  return (
    <div>
      <ReportsDetailsViewHeader />
      <ReportsDetailsViewOverview />
    </div>
  )
}

export default ReportsDetailsViewPage
